import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ISelectItems } from '@shared/models/selectItems';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({providedIn: 'root'})

export class PublicComplaintService {
  public api: string = environment.publicApi + 'Complaint/'
  private http = inject(HttpClient);

  getCounties(): Observable<ISelectItems[]>{
    return this.http.get<ISelectItems[]>(this.api + 'getCounties', httpOptions);
  }

  saveComplaint(form: FormData): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'saveComplaint', form);
  }

  downloadHelpFile(): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'downloadHelpFile', { responseType: 'blob' as 'json' });
  }
}
